var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHaunt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    width: "auto",
    height: "auto",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.92
    },
    fill: "current",
    stroke: "current",
    d: "M26.5 18.5h3c.27 5.5 2.27 10.167 6 14 18.667-13.333 37.333-13.333 56 0 3.73-3.833 5.73-8.5 6-14 1.322-.17 2.489.163 3.5 1 4.932 8.22 4.432 16.053-1.5 23.5L84 54.5a25.792 25.792 0 0 0-2-8 125.409 125.409 0 0 1-12 23 71.628 71.628 0 0 0-1 22 6.975 6.975 0 0 1 2.5-3.5 79.337 79.337 0 0 0 24-6l3.5-3.5a354.494 354.494 0 0 1 7-20c2.285-3.392 5.452-5.059 9.5-5a55.635 55.635 0 0 1-3.5 10c.229 8.537-1.938 16.37-6.5 23.5 1.973.496 3.973.662 6 .5.17 1.322-.163 2.489-1 3.5l-26 14c-14.79 4.899-29.457 4.565-44-1-7.872-4.7-15.872-9.2-24-13.5-.886-.825-1.219-1.825-1-3a9.864 9.864 0 0 0 6-1c-4.369-6.99-6.535-14.656-6.5-23a60.9 60.9 0 0 1-3.5-10c4.048-.059 7.215 1.608 9.5 5a110.95 110.95 0 0 1 6 17c2.007 5.338 5.84 8.504 11.5 9.5l17 3a6.975 6.975 0 0 1 2.5 3.5c.8-7.39.467-14.722-1-22a125.409 125.409 0 0 1-12-23 25.792 25.792 0 0 0-2 8L27.5 43c-6.23-7.898-6.564-16.065-1-24.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.807
    },
    fill: "current",
    stroke: "current",
    d: "M31.5 57.5a574.782 574.782 0 0 1 6 5 4.452 4.452 0 0 0 1.5-2c4.907 4.407 8.407 9.74 10.5 16-13.427.903-19.427-5.43-18-19Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.789
    },
    fill: "current",
    stroke: "current",
    d: "M93.5 57.5c1.165.996 1.832 2.33 2 4 .505 6.503-2.161 11.003-8 13.5a54.884 54.884 0 0 1-10 2.5c1.017-7.035 4.35-12.702 10-17a4.452 4.452 0 0 1 1.5 2 31.444 31.444 0 0 0 4.5-5Z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHaunt);
export default __webpack_public_path__ + "static/media/haunt.8996d17f.svg";
export { ForwardRef as ReactComponent };